import { render, staticRenderFns } from "./AnneeScolaireContainer.vue?vue&type=template&id=449f6035&"
import script from "./AnneeScolaireContainer.vue?vue&type=script&lang=js&"
export * from "./AnneeScolaireContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports